import {IsNumberString, ValidationOptions} from 'class-validator';

export function MyIsNumberString(validationOptions: ValidationOptions = {}) {
  const options = Object.assign({message: `This field should be a number`}, validationOptions);
  return IsNumberString(options);
}
